import React from "react";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  LocalizationProvider,
  DesktopDatePicker,
  DesktopDateTimePicker,
} from "@mui/x-date-pickers";
import { Timestamp } from "firebase/firestore";
import dayjs from "dayjs";
import "../css/customDatePickerStyles.css";

export default function DatePickerComponentWithTime(props) {
  const handleChange = (date) => {
    const timestamp = Timestamp.fromMillis(date.valueOf());
    props.onChange(timestamp);
  };

  const dateObject =
    props.value && typeof props.value.toMillis === "function"
      ? dayjs(new Date(props.value.toMillis()))
      : props.value;

  return (
    <div className="input-label-container">
      <div className="input-label">
        {props.title}{" "}
        {props.isRequired && <span style={{ color: "red" }}>*</span>}
      </div>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDateTimePicker // Utiliser DesktopDateTimePicker ici
          inputFormat="DD/MM/YYYY HH:mm" // Ajouter le format d'heure et de minute
          textField={
            <TextField
              variant="outlined"
              error={false}
              InputProps={{
                style: {
                  padding: "10px",
                  fontSize: "18px",
                  height: 30,
                },
              }}
              sx={{
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "grey",
                },
              }}
            />
          }
          value={dateObject}
          onChange={handleChange}
        />
      </LocalizationProvider>
    </div>
  );
}
